export default {
    count_down: {
        segundos: 'Seconds',
        minuto: 'Minute',
        minutos: 'Minutes'
    },
    paginator: {
        quantidade_pagina: 'Quantity per page',
        anterior: 'Previous',
        proxima: 'Next',
        pagina: 'Page',
        de: 'of',
        ir_para: 'Go to page',
        por_pagina: 'Per page'
    },
    select: {
        sem_resultados: 'No results for',
        digite: 'Type',
        letras: 'letters',
        nenhum_resultado: 'No results for',
        deseja_incluir: 'Do you want to include?',
        sim: 'Yes',
    },
    table_data: {
        valor: 'Value',
        filtros: 'Filters',
        gerenciar_colunas: 'Manage Columns',
        selecionar_todas: 'Select All',
        desmarcar_todas: 'Deselect All',
    },
    bulk_form: {
        alterando: 'You are changing ',
        registros: 'records.',
        label_quantidade: 'Number of items with this data:',
        aplicar: 'To Apply',
        messages: {
            quantidade: 'Insert amount of records you want to insert!'
        }
    },
    form_generator: {
        habilitado: 'Enabled',
        desabilitado: 'Disabled',
        sem_informacao: 'No data found'
    },
    exam_form: {
        nome: 'Name',
        codigo: 'Code',
        componente: 'Component',
        material: 'Material',
        metodo: 'Method',
        tempo: 'Time',
        escala: 'Scale'
    },
    exam_wizard_form: {
        sub_exame: 'Sub-exam'
    },
    import_controls: {
        escolha_planilha: 'Choose a spreadsheet to import or drag here...',
        baixar_planilha: 'Download spreadsheet example',
        planilha_selecionada: 'Selected spreadsheet',
        selecione_integacoes: 'Select Integrations',
        integracao_cliente: 'Client Integration',
        integracao_suporte: 'Support Integration',
        importar_exames: 'Import exams'
    },
    import_controls: {
        escolha_planilha: 'Elija una hoja de cálculo para importar o arrástrela aquí...',
        baixar_planilha: 'Descargar ejemplo de hoja de cálculo',
        planilha_selecionada: 'Hoja de cálculo seleccionada',
        selecione_integacoes: 'Seleccione Integraciones',
        integracao_cliente: 'Integración Cliente',
        integracao_suporte: 'Integración Soporte',
        importar_exames: 'Importar exámenes'
    },
    row_info: {
        titulo: 'Exams related to the synonym'
    },    
    data_table: {
        todos: 'All',
        nenhum_resultado_encontrado: 'No results found',
        linhas_por_pagina: 'Lines per page',
        proximo: 'Next',
        anterior: 'Previous'
    },
    monitoring_filter: {
        legenda: 'Subtitle',
        filtros: 'Filters',
        modo_monitor: 'Monitor Mode'
    },
    subtitle: {
        titulo: 'VNS Legend',
        vns_novo: 'New',
        vns_novo_desc: 'VNS created awaiting IP provisioning. Not available to the client.',
        vns_ativo: 'Online',
        vns_ativo_desc: 'VNS active and connected to the internet.',
        vns_desconectado: 'Disconnected',
        vns_desconectado_desc: 'VNS label connected to power and internet, but not connected to the printer or printer is off.',
        vns_offline: 'Offline',
        vns_offline_desc: 'VNS not connected to power and/or without internet.',
        vns_em_analise: 'Under Analysis',
        vns_em_analise_desc: 'VNS functional, but with high temperature.'
    }    
}
